import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { FeatureGatingContext, SettingsContext, useEntitlements } from "../../contexts";
import { LimitReachedModal } from "../../components/LimitReachedModal";
import { Button, ButtonGroup } from "../../components/ui";

export function ListingsTopButtons({ showLookbookBtn = true }) {
  const history = useHistory();
  const { isShopify, iframeQueryParams } = useContext(SettingsContext);
  const { checkFeatureQuota } = useContext(FeatureGatingContext);
  const { limits, gatingActive, refresh, hasFeature } = useEntitlements();
  const [showLimitModal, setShowLimitModal] = useState(false);
  // Lookbook generation (Feature 13) — the button goes with the plan.
  const hasLookbooks = hasFeature("lookbook_generation");

  // The counter moves when listings are created elsewhere in the session —
  // re-pull the switchboard when this page mounts so the chip is current.
  useEffect(() => { refresh(); }, [refresh]);

  const listingLimit = limits?.limit_listings;
  const hasLimit = listingLimit?.max !== null && listingLimit?.max !== undefined;
  const atCap = hasLimit && (listingLimit.used || 0) >= listingLimit.max;

  const onCreateNewListing = async () => {
    // Plan limit (Feature 1): explain and offer an upgrade request instead
    // of navigating to a form the server will refuse. Only intercepts when
    // enforcement is actually on — the chip alone informs before that.
    if (gatingActive && atCap) {
      setShowLimitModal(true);
      return;
    }

    // Legacy per-user merchant quota (unchanged).
    const allowed = await checkFeatureQuota(
      FeatureGatingContext.features.LISTINGS
    );

    if (!allowed) {
      return;
    }

    history.push(`/product/create?${iframeQueryParams}`);
  };

  const limitChip = hasLimit && (
    <span className={`rc-limit-chip ${atCap ? "rc-limit-chip--full" : ""}`}>
      {listingLimit.used || 0} of {listingLimit.max} this month
    </span>
  );

  // Page-header CTA hero recipe (DESIGN-SYSTEM §4): New listing is the one primary,
  // New lookbook the quieter secondary beside it.
  return (
    <div className="d-flex align-items-center flex-wrap gap-2">
      {limitChip}

      <ButtonGroup align="end">
        {!isShopify && showLookbookBtn && hasLookbooks && (
          <Button variant="secondary" size="lg" hero to="/lookbooks/new" data-btn="lookbook-new">
            New lookbook
          </Button>
        )}
        <Button variant="primary" size="lg" hero onClick={onCreateNewListing} data-btn="listing-new">
          New listing
        </Button>
      </ButtonGroup>

      {showLimitModal && (
        <LimitReachedModal
          title="Monthly listing limit reached"
          body={`You've used all ${listingLimit?.max} listings included in your plan this month.`}
          resetsAt={listingLimit?.resets_at}
          onClose={() => setShowLimitModal(false)}
        />
      )}
    </div>
  );
}
